<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: lc
 * @LastEditTime: 2024-12-30 17:02:37
-->
<template>
  <div class="studymodule-list">
    <Form ref="ruleForm"
          :model="viewData"
          :rules="rules"
          action="javascript:void(0)">
      <!-- <FormItem label="自测名称"
                  prop="name">
          <Input v-model="viewData.name" />
        </FormItem> -->
      <FormItem label="单选题数量"
                prop="dan_num">
        <Input type="number"
               style="width: 150px;"
               v-model="viewData.dan_num" />
      </FormItem>
      <FormItem label="单选题分数"
                prop="dan_score">
        <Input type="number"
               style="width: 150px;"
               v-model="viewData.dan_score" />
      </FormItem>
      <FormItem label="单选题总分"
                prop="duo_num">
        <Input v-model="viewData.dan_num*viewData.dan_score"
               style="width: 150px;"
               disabled></Input>
      </FormItem>
      <FormItem label="多选题数量"
                prop="duo_num">
        <Input type="number"
               style="width: 150px;"
               v-model="viewData.duo_num" />
      </FormItem>
      <FormItem label="多选题分数"
                prop="duo_score">
        <Input type="number"
               style="width: 150px;"
               v-model="viewData.duo_score" />
      </FormItem>
      <FormItem label="多选题总分"
                prop="duo_num">
        <Input v-model="viewData.duo_num*viewData.duo_score"
               style="width: 150px;"
               disabled></Input>
      </FormItem>
      <FormItem label="判断题数量"
                prop="pan_num">
        <Input type="number"
               style="width: 150px;"
               v-model="viewData.pan_num" />
      </FormItem>
      <FormItem label="判断题分数"
                prop="pan_score">
        <Input type="number"
               style="width: 150px;"
               v-model="viewData.pan_score" />
      </FormItem>
      <FormItem label="判断题总分"
                prop="duo_num">
        <Input v-model="viewData.pan_num*viewData.pan_score"
               style="width: 150px;"
               disabled></Input>
      </FormItem>
      <FormItem label="总分"
                prop="duo_num">
        <Input v-model="viewData.pan_num*viewData.pan_score + viewData.duo_num*viewData.duo_score + viewData.dan_num*viewData.dan_score"
               style="width: 150px;"
               disabled></Input>
      </FormItem>
      <!-- <FormItem label="自测时间"
                  prop="time_limit">
          <Input type="number"
        
                 v-model="viewData.time_limit" /><span>分钟</span>
        </FormItem> -->
      <FormItem>
        <Button type="primary"
                @click="tijiao('ruleForm')">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      viewData: {
        sitename: '',
        describe: '',
        person: '',
        phone: '',
        email: '',
        address: '',
        youbian: '',
        beian_title: '',
        beian_url: '',
      },
      rules: {
        sitename: [
          {
            required: true,
            message: "请输入网站名称",
            trigger: "blur",
          },
        ],
        describe: [
          {
            required: true,
            message: "请输入描述",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入联系方式",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
  },
  created () {
  },
  mounted () {
    this.resetForm()
    this.getConfig()
  },
  methods: {
    // 获取配置详情
    getConfig () {
      this.$api.tiku.config(this.viewData).then(res => {
        if (res.code == 200) {
          this.viewData = res.result
        } else {
          that.$message.error(res.message);
        }
      })
    },
    /**
     * @name: 提交
     * @param {*} formName
     * @return {*}
     * @desc:
     */
    tijiao (formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 编辑
          this.$api.tiku.editconfig(this.viewData).then(res => {
            if (res.code == 200) {
              that.getConfig()
              this.$Message.success(res.msg);
            } else {
              this.$Message.error(res.msg);
            }
          })

        } else {
          // this.$message.warning(this.$t('form.verifyMsg'))
        }
      })
    },
    /**
     * @name: 清空form
     * @return {*}
     * @desc:
     */
    resetForm () {
      this.viewData = {
        sitename: '',
        describe: '',
        person: '',
        phone: '',
        email: '',
        address: '',
        youbian: '',
        beian_title: '',
        beian_url: '',
      }
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
